import { Divider } from "@mui/material";
import AlbumListPager from "./AlbumListPager";

const AlbumListFooter = () => {
    return (
        <div className="d-flex flex-column gap-0_5 px-1 pb-0_5">
            <Divider />
            <div className="full-width d-flex flex-row jc-center ai-center gap-0_5">
                <AlbumListPager />
            </div>
        </div>
    )
}

export default AlbumListFooter;